export default {
  data () {
    return {
      rellax: {
        speed: -10
      }
    }
  },

  methods: {
    destroyRellax () {
      this.rellax = false
    }
  },

  mounted () {
    if (!this.withMobileRellax && window.innerWidth < 1025) {
      this.destroyRellax()
    }
  }
}
